import { IncidentId } from '@collector/sportsapi-client-legacy'

import { QueueIncident } from './types.js'

export type QueueIncidentErrorHandler = (error: unknown) => boolean

export type QueueIncidentErrorConfig<T extends IncidentId = IncidentId> = Map<
  T,
  QueueIncidentErrorHandler
>

function getIncidentId(queueIncident: QueueIncident): IncidentId | null {
  if (queueIncident.type === 'Add' || queueIncident.type === 'Update') {
    return queueIncident.payload.incident_id
  }

  return null
}

/**
 * Checks if a queue error should be treated as "allowed" and not considered an actual error
 * @param error - The error object from processing the incident
 * @param queueIncident - The queue incident that caused the error
 * @param queueErrorConfig - Configuration record for handling specific incident errors
 * @returns true if the error should be ignored (treated as success), false if it should be treated as an error
 */
export function isAllowedQueueIncidentError(
  error: unknown,
  queueIncident: QueueIncident,
  queueErrorConfig: QueueIncidentErrorConfig,
): boolean {
  const incidentId = getIncidentId(queueIncident)
  if (incidentId === null) {
    return false
  }

  const errorHandler = queueErrorConfig.get(incidentId)

  if (!errorHandler) {
    return false
  }

  return errorHandler(error)
}
